import classes from './CustomLinearProgress.module.scss';

function CustomLinearProgress(props) {
  const { progress, fullLength } = props;
  return (
    <div className={classes.progress} style={{ width: fullLength }}>
      <div
        aria-label="progressBar"
        className={classes.progressBar}
        role="progressbar"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}

export default CustomLinearProgress;
